// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.postdetails_area {
    padding: 4rem 0 0;
}
.details-box {
    background: #F3F3F3 0% 0% no-repeat padding-box;
border-radius: 15px;
opacity: 1;
padding: 20px;
}
.post-customer-information-row {
    display: flex;
    align-items: stretch;
    gap: 11px;
}
.information-section p {
    font: normal normal 600 14px/4px Poppins;
letter-spacing: 0px;
color: #333333;
}
.post-customer-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
}
.img-post-section {
    padding: 3rem;
    background: transparent linear-gradient(167deg, #36D1DC 0%, #5B86E5 100%) 0% 0% no-repeat padding-box;
border-radius: 10px;
}
.post-padding {
    padding: 2rem 0 0;
}
.post-detail-area {
    /* width: 170px;
    height: 180px;
    border-radius: 5px;
    overflow: hidden; */
    margin: 10px 0px 18px;
}
.post-detail-area img{
    width: 100%;
    object-fit: contain;
}
.post-details-information-section-box {
    background: #F3F3F3 0% 0% no-repeat padding-box;
border-radius: 15px;
opacity: 1;
padding: 10px;
height: 56rem;
}
.post-comment-img-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0 0;
}
.post-timeline-brand-content {
    height: 473px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 10px;
    margin-bottom: 15px;
    padding: 0px 10px 0;
}
.post-comment-img-row img {
    width: 30px;
}
.post-comment-img-row p {
    font: normal normal 600 12px/20px Poppins;
    letter-spacing: 0px;
    color: #000000;
}
.post-timeline-brand-content::-webkit-scrollbar {
    display: none;
}

/* tab-section */
.resource_tab {
    border-bottom: 1px solid #787878;
}
.resource_tab .nav-link {
    color: #333333
}
.fa-solid, .fas {
    font-family: "Font Awesome 6 Free";
    font-weight: 900;
}
.fa-solid, .fas {
    font-family: "Font Awesome 6 Free";
    font-weight: 900;
}
.fa-file-alt:before, .fa-file-lines:before, .fa-file-text:before {
    content: "\\f15c";
}
/* .nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fdca0f;
    background-color: transparent;
} */

.post-home_page_dialog .select_for_img {
    /* height: 230px; */
}
.post-select_for_img {
    height: 300px;
    overflow: hidden;
    border-radius: 4px;
    position: relative;
}
.post-select_for_img img {
    width: 100%;
    object-fit: contain;
}
.post-like_share_product {
    position: absolute;
    top: 10px;
    right: 10px;
}
.post-like_share_product i {
    display: block;
    color: #000;
    background: #fff;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;
    transition: all 0.4s ease-in-out;
}
.post-home_page_dialog .select_for_text {
    padding: 10px 5px;
    font-size: 13px;
    font-weight: 600;
}
.post-real_price {
    font-weight: 500;
    color: red;
}
.post-space_between2 {
    justify-content: space-between;
}
.post-display_flex {
    display: flex;
}
.post-old_price {
    text-decoration: line-through;
    color: grey;
    opacity: 0.4;
}
.post-like_share_product i:hover {
    display: block;
    color: #fff;
    background: #ffa71d;
}

/* tab-style */






.wrapper .line {
  width: 50%;
  margin: 50px auto 0 auto;
  height: 1px;
  background-color: #c3d2e3;
}

h2.tab-title {
  font-weight: 300;
}
h2.tab-title.tab-primary {
  color: #636983;
}
h2.tab-title.tab-success {
  color: #51a14c;
}
h2.tab-title.tab-default {
  color: #525252;
}
h2.tab-title.tab-warning {
  color: #b12222;
}

 

.tabs {
  text-align: left;
  position: relative;
}
.tabs input {
  position: absolute;
  opacity: 0;
  margin: 0;
  padding: 0;
}
.tabs input + label {
  font-weight: 300;
  color: #666;
  margin: 10px 0;
  width: 110px;
  cursor: pointer;
  display: inline-block;
  transition: all 0.3s;
  text-align: center;
  font-size: 12px;
  border: none;
}
.tabs input + label:hover {
  color: #777;
}
.tabs .tabsShadow {
  width: 100%;
  padding: 10px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  position: absolute;
  height: 35px;
  z-index: 0;
  top: 0;
  pointer-events: none;
}

.content {
  margin: 0px auto;
  text-align: left;
  color: #666;
  font-size: 13px;
  line-height: 20px;
  position: relative;
  height: 220px;
}
.content .item {
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  position: absolute;
  padding: 10px 20px;
}
.content p {
  margin: 10px 0;
}

.glider {
  width: 110px;
  height: 3px;
  background: linear-gradient(90deg, #5b3cc4 0%, #3c6cc4 100%);
  border-radius: 3px;
  position: absolute;
  box-shadow: 0px 0px 8px 0px rgba(91, 60, 196, 0.4);
  transition: all 0.3s;
}

#tab-1:checked ~ .glider {
  left: 0px;
}

#tab-2:checked + label {
  color: #51a14c;
}
#tab-2:checked ~ .glider {
  background: linear-gradient(90deg, #51a14c 0%, #10c33e 100%);
  box-shadow: 0px 0px 8px 0px rgba(47, 187, 12, 0.62);
}
#tab-2:checked ~ .glider {
  left: 113px;
}

#tab-3:checked + label {
  color: #525252;
}
#tab-3:checked ~ .glider {
  background: linear-gradient(90deg, #4a4a4a 0%, #9b9b9b 100%);
}
#tab-3:checked ~ .glider {
  left: 226px;
}

#tab-4:checked + label {
  color: #b12222;
}
#tab-4:checked ~ .glider {
  background: linear-gradient(90deg, #b93232 0%, #ff5d5d 100%);
  box-shadow: 0px 0px 8px 0px rgba(231, 13, 93, 0.57);
}
#tab-4:checked ~ .glider {
  left: 339px;
}

#tab-1:checked ~ section #content-1,
#tab-2:checked ~ section #content-2,
#tab-3:checked ~ section #content-3,
#tab-4:checked ~ section #content-4 {
  opacity: 1;
  visibility: visible;
}

.customer-img-section img {
    width: 100%;
    object-fit: contain;
    height: 50px;
    border-radius: 30px;
}
@media (max-width: 700px) {
  .tabs input + label, .glider {
    width: 70px;
  }

  #tab-1:checked ~ .glider {
    left: 0px;
  }

  #tab-2:checked ~ .glider {
    left: 73px;
  }

  #tab-3:checked ~ .glider {
    left: 146px;
  }

  #tab-4:checked ~ .glider {
    left: 219px;
  }
}
.information-section h6 {
    font: normal normal normal 11px/18px Poppins;
letter-spacing: 0px;
color: #333333;
}
.customer-comment-details {
    font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/singlepost/singlepost.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;AACrB;AACA;IACI,+CAA+C;AACnD,mBAAmB;AACnB,UAAU;AACV,aAAa;AACb;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;AACb;AACA;IACI,wCAAwC;AAC5C,mBAAmB;AACnB,cAAc;AACd;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,qGAAqG;AACzG,mBAAmB;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;;;uBAGmB;IACnB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,+CAA+C;AACnD,mBAAmB;AACnB,UAAU;AACV,aAAa;AACb,aAAa;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,gCAAgC;AACpC;AACA;IACI;AACJ;AACA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;;;GAGG;;AAEH;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;AAChB;AACA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA,cAAc;;;;;;;AAOd;EACE,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;;;AAIA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,4DAA4D;EAC5D,kBAAkB;EAClB,kBAAkB;EAClB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;AACA;EACE,4DAA4D;EAC5D,mDAAmD;AACrD;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,4DAA4D;EAC5D,mDAAmD;AACrD;AACA;EACE,WAAW;AACb;;AAEA;;;;EAIE,UAAU;EACV,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;AACA;EACE;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;AACA;IACI,4CAA4C;AAChD,mBAAmB;AACnB,cAAc;AACd;AACA;IACI,eAAe;AACnB","sourcesContent":["\n.postdetails_area {\n    padding: 4rem 0 0;\n}\n.details-box {\n    background: #F3F3F3 0% 0% no-repeat padding-box;\nborder-radius: 15px;\nopacity: 1;\npadding: 20px;\n}\n.post-customer-information-row {\n    display: flex;\n    align-items: stretch;\n    gap: 11px;\n}\n.information-section p {\n    font: normal normal 600 14px/4px Poppins;\nletter-spacing: 0px;\ncolor: #333333;\n}\n.post-customer-row {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n}\n.img-post-section {\n    padding: 3rem;\n    background: transparent linear-gradient(167deg, #36D1DC 0%, #5B86E5 100%) 0% 0% no-repeat padding-box;\nborder-radius: 10px;\n}\n.post-padding {\n    padding: 2rem 0 0;\n}\n.post-detail-area {\n    /* width: 170px;\n    height: 180px;\n    border-radius: 5px;\n    overflow: hidden; */\n    margin: 10px 0px 18px;\n}\n.post-detail-area img{\n    width: 100%;\n    object-fit: contain;\n}\n.post-details-information-section-box {\n    background: #F3F3F3 0% 0% no-repeat padding-box;\nborder-radius: 15px;\nopacity: 1;\npadding: 10px;\nheight: 56rem;\n}\n.post-comment-img-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 0 0;\n}\n.post-timeline-brand-content {\n    height: 473px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    margin-top: 10px;\n    margin-bottom: 15px;\n    padding: 0px 10px 0;\n}\n.post-comment-img-row img {\n    width: 30px;\n}\n.post-comment-img-row p {\n    font: normal normal 600 12px/20px Poppins;\n    letter-spacing: 0px;\n    color: #000000;\n}\n.post-timeline-brand-content::-webkit-scrollbar {\n    display: none;\n}\n\n/* tab-section */\n.resource_tab {\n    border-bottom: 1px solid #787878;\n}\n.resource_tab .nav-link {\n    color: #333333\n}\n.fa-solid, .fas {\n    font-family: \"Font Awesome 6 Free\";\n    font-weight: 900;\n}\n.fa-solid, .fas {\n    font-family: \"Font Awesome 6 Free\";\n    font-weight: 900;\n}\n.fa-file-alt:before, .fa-file-lines:before, .fa-file-text:before {\n    content: \"\\f15c\";\n}\n/* .nav-pills .nav-link.active, .nav-pills .show>.nav-link {\n    color: #fdca0f;\n    background-color: transparent;\n} */\n\n.post-home_page_dialog .select_for_img {\n    /* height: 230px; */\n}\n.post-select_for_img {\n    height: 300px;\n    overflow: hidden;\n    border-radius: 4px;\n    position: relative;\n}\n.post-select_for_img img {\n    width: 100%;\n    object-fit: contain;\n}\n.post-like_share_product {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n.post-like_share_product i {\n    display: block;\n    color: #000;\n    background: #fff;\n    border-radius: 50%;\n    height: 30px;\n    width: 30px;\n    text-align: center;\n    line-height: 30px;\n    margin-bottom: 10px;\n    transition: all 0.4s ease-in-out;\n}\n.post-home_page_dialog .select_for_text {\n    padding: 10px 5px;\n    font-size: 13px;\n    font-weight: 600;\n}\n.post-real_price {\n    font-weight: 500;\n    color: red;\n}\n.post-space_between2 {\n    justify-content: space-between;\n}\n.post-display_flex {\n    display: flex;\n}\n.post-old_price {\n    text-decoration: line-through;\n    color: grey;\n    opacity: 0.4;\n}\n.post-like_share_product i:hover {\n    display: block;\n    color: #fff;\n    background: #ffa71d;\n}\n\n/* tab-style */\n\n\n\n\n\n\n.wrapper .line {\n  width: 50%;\n  margin: 50px auto 0 auto;\n  height: 1px;\n  background-color: #c3d2e3;\n}\n\nh2.tab-title {\n  font-weight: 300;\n}\nh2.tab-title.tab-primary {\n  color: #636983;\n}\nh2.tab-title.tab-success {\n  color: #51a14c;\n}\nh2.tab-title.tab-default {\n  color: #525252;\n}\nh2.tab-title.tab-warning {\n  color: #b12222;\n}\n\n \n\n.tabs {\n  text-align: left;\n  position: relative;\n}\n.tabs input {\n  position: absolute;\n  opacity: 0;\n  margin: 0;\n  padding: 0;\n}\n.tabs input + label {\n  font-weight: 300;\n  color: #666;\n  margin: 10px 0;\n  width: 110px;\n  cursor: pointer;\n  display: inline-block;\n  transition: all 0.3s;\n  text-align: center;\n  font-size: 12px;\n  border: none;\n}\n.tabs input + label:hover {\n  color: #777;\n}\n.tabs .tabsShadow {\n  width: 100%;\n  padding: 10px;\n  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.04);\n  box-sizing: border-box;\n  position: absolute;\n  height: 35px;\n  z-index: 0;\n  top: 0;\n  pointer-events: none;\n}\n\n.content {\n  margin: 0px auto;\n  text-align: left;\n  color: #666;\n  font-size: 13px;\n  line-height: 20px;\n  position: relative;\n  height: 220px;\n}\n.content .item {\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s;\n  position: absolute;\n  padding: 10px 20px;\n}\n.content p {\n  margin: 10px 0;\n}\n\n.glider {\n  width: 110px;\n  height: 3px;\n  background: linear-gradient(90deg, #5b3cc4 0%, #3c6cc4 100%);\n  border-radius: 3px;\n  position: absolute;\n  box-shadow: 0px 0px 8px 0px rgba(91, 60, 196, 0.4);\n  transition: all 0.3s;\n}\n\n#tab-1:checked ~ .glider {\n  left: 0px;\n}\n\n#tab-2:checked + label {\n  color: #51a14c;\n}\n#tab-2:checked ~ .glider {\n  background: linear-gradient(90deg, #51a14c 0%, #10c33e 100%);\n  box-shadow: 0px 0px 8px 0px rgba(47, 187, 12, 0.62);\n}\n#tab-2:checked ~ .glider {\n  left: 113px;\n}\n\n#tab-3:checked + label {\n  color: #525252;\n}\n#tab-3:checked ~ .glider {\n  background: linear-gradient(90deg, #4a4a4a 0%, #9b9b9b 100%);\n}\n#tab-3:checked ~ .glider {\n  left: 226px;\n}\n\n#tab-4:checked + label {\n  color: #b12222;\n}\n#tab-4:checked ~ .glider {\n  background: linear-gradient(90deg, #b93232 0%, #ff5d5d 100%);\n  box-shadow: 0px 0px 8px 0px rgba(231, 13, 93, 0.57);\n}\n#tab-4:checked ~ .glider {\n  left: 339px;\n}\n\n#tab-1:checked ~ section #content-1,\n#tab-2:checked ~ section #content-2,\n#tab-3:checked ~ section #content-3,\n#tab-4:checked ~ section #content-4 {\n  opacity: 1;\n  visibility: visible;\n}\n\n.customer-img-section img {\n    width: 100%;\n    object-fit: contain;\n    height: 50px;\n    border-radius: 30px;\n}\n@media (max-width: 700px) {\n  .tabs input + label, .glider {\n    width: 70px;\n  }\n\n  #tab-1:checked ~ .glider {\n    left: 0px;\n  }\n\n  #tab-2:checked ~ .glider {\n    left: 73px;\n  }\n\n  #tab-3:checked ~ .glider {\n    left: 146px;\n  }\n\n  #tab-4:checked ~ .glider {\n    left: 219px;\n  }\n}\n.information-section h6 {\n    font: normal normal normal 11px/18px Poppins;\nletter-spacing: 0px;\ncolor: #333333;\n}\n.customer-comment-details {\n    font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
